import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export interface ZuulLoaderProps {
  /** Message shown under the spinner. */
  text?: string;
}

/** Centred loading state used while a view's data is in flight. */
export default function ZuulLoader({ text }: ZuulLoaderProps) {
  return (
    <Stack
      spacing={3}
      sx={{ height: '100%', mt: 2, textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}
    >
      <CircularProgress size={40} />
      <Typography color='text.secondary'>{text || 'Loading ...'}</Typography>
    </Stack>
  );
}
